<template>
  <div>
    <div class="page-container">
      <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item>blockInfo</el-breadcrumb-item>
    </el-breadcrumb> -->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <span class="page-title">财务报表</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>综合账单</el-breadcrumb-item>
      </el-breadcrumb>
      <el-card class="page-content" shadow="never">
        <div class="page-actions">
          <el-input v-model="val1" placeholder="请输入用户Id" clearable></el-input>
          <el-select v-model="coin" placeholder="请筛选币种" clearable>
            <el-option
              v-for="item in allCoins"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-select v-model="type" placeholder="请筛选订单类型" clearable>
            <el-option
              v-for="item in allTypesOptios"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-date-picker
          v-model="value2"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <a  @click="getExcel" target="_blank" >导出Excel</a>
        </div>
        <user-list @refresh="refreshList"></user-list>
      </el-card>
    </div>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState,mapGetters } from "vuex";
import UserList from "./components/list";
export default {
  components: {
    UserList,
  },
  data() {
    return {
        val1:'',
       coin:'',
       type:'',
        value2:'',
        page:1,size:25,
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
    };
  },
  computed: {
    ...mapState('financeBill',['allCoins','allTypes']),
    ...mapGetters('financeBill',['allTypesOptios']),
  },
  methods: {
    ...mapActions('financeBill',['getOrderList','exportExcel','getFbsPairs','getAllCoins','getAllTypes']),
    refreshList(data={}){
        this.page=data.page
        this.size=data.size
        this.getOrderList({
          endTime: this.value2?this.value2[1].valueOf():'',
            startTime: this.value2?this.value2[0].valueOf():'',
        coin:this.coin,
        type:this.type,
        page:this.page,size:this.size,
        userId:this.val1,
        ...data
    })
    },
    handleSearch(){
        this.getOrderList({
          endTime: this.value2?this.value2[1].valueOf():'',
            startTime: this.value2?this.value2[0].valueOf():'',
        coin:this.coin,
        type:this.type,
        page:1,size:this.size,
        userId:this.val1
    })
    },
    getExcel(){
        this.exportExcel({
          endTime: this.value2?this.value2[1].valueOf():'',
            startTime: this.value2?this.value2[0].valueOf():'',
            coin:this.coin,
            type:this.type,
            userId:this.val1
        }).then(res=>{
         
            const link=document.createElement('a') 
            const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
            link.style.display = 'none'
            // 设置连接
            link.href = URL.createObjectURL(blob)  //将文件流转化为blob地址
            console.log('link-href',link.href);
            link.download = '综合账单统计报表'
            document.body.appendChild(link)
            // 模拟点击事件
            link.click()  //设置点击事件
       
       

      }).catch(error=>{
        this.$message.error(error)
      });
    }
  },
  created() {
    this.getOrderList({
      endTime: this.value2?this.value2[1].valueOf():'',
            startTime: this.value2?this.value2[0].valueOf():'',
        coin:this.coin,
        type:this.type,
        page:this.page,size:this.size,
        userId:this.val1
    })
    // this.getFbsPairs()
    this.getAllCoins()
    this.getAllTypes()
  },
};
</script>

<style lang="less" scoped>
.page-actions {
  margin-bottom: 10px;
}
</style>
